// DAS-2181: Terminal Zone Configuration
// Maps cards to terminal layout zones (the WHERE).
// Card definitions own the display data (the WHAT) via terminal.hero / terminal.rows / terminal.tableCol.

export const terminalZoneConfig = {
  hero: [
    { cardId: 'portfolio', modal: 'portfolio' },
    { cardId: 'income', modal: 'income' },
    { cardId: 'performance', modal: 'performance' },
    { cardId: 'momentum', modal: 'momentum' },
    { cardId: 'cash', modal: null },
    { cardId: 'risk', modal: 'risk' },
  ],

  // Phase 2: Three analysis panels — each merges multiple cards
  panels: [
    {
      id: 'risk_allocation',
      title: 'risk & allocation',
      cardIds: ['risk', 'exposures', 'asset_allocation', 'esg'],
      badgeCardId: 'risk',
      modal: 'risk',
    },
    {
      id: 'fundamentals_signals',
      title: 'fundamentals & signals',
      cardIds: ['fundamentals', 'institutional_trend', 'news_trend'],
      badgeCardId: 'fundamentals',
      modal: 'fundamentals',
    },
    {
      id: 'timeline_alerts',
      title: 'timeline & alerts',
      cardIds: ['timeline', 'alerts'],
      badgeCardId: 'alerts',
      modal: 'alerts',
    },
  ],

  // Phase 3: Positions table columns
  table: {
    columns: [
      { key: 'ticker', header: 'ticker' },
      { key: 'name', header: 'name' },
      { key: 'weight', header: 'weight' },
      { key: '1m_return', header: '1M ret.', cardId: 'performance' },
      { key: 'momentum', header: 'momentum', cardId: 'momentum' },
      { key: 'score', header: 'score', cardId: 'fundamentals' },
      { key: 'esg', header: 'ESG', cardId: 'esg' },
      { key: 'alert', header: '\u26A0', cardId: 'alerts' },
    ],
  },

  // Phase 3: Sidebar panels
  sidebar: {
    panels: [
      { id: 'news_feed', title: 'news feed', cardId: 'news', modal: 'news' },
      { id: 'performance_summary', title: 'performance', cardId: 'performance', modal: 'performance' },
    ],
  },

  // Top bar tabs (non-functional placeholders for Phase 1)
  tabs: [
    { id: 'overview', label: 'overview', active: true },
    { id: 'positions', label: 'positions', active: false },
    { id: 'alerts', label: 'alerts', active: false, showBadge: true },
    { id: 'tools', label: 'tools', active: false },
  ],
};

export const ANNOTATION_REGIONS = {
  hero: (cardId) => `hero.${cardId}`,
  panel: (panelId) => `panels.${panelId}`,
  panelRow: (panelId, rowIdx) => `panels.${panelId}.row.${rowIdx}`,
  table: () => 'table',
  tableColumn: (colKey) => `table.col.${colKey}`,
  sidebar: (panelId) => `sidebar.${panelId}`,
  topbar: () => 'topbar',
  statusbar: () => 'statusbar',
};
